// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export default (table, rotations) => {
    
    // Make a deep copy of the table, and return that. This will allow us to rotate the table, without rendering the rotations being made. 
    const tbl = JSON.parse(JSON.stringify(table))
    if (!tbl || !tbl.rows) return; 

    const rows = [...tbl.rows];
    if (!rows || !rows.length) return; 

    if (!rotations || !Object.keys(rotations).length) return tbl; 

    const rotate = (obj, rotationIdx) => {
        const turns = Math.round((rotations[rotationIdx] ) / 90) % 4;

        const x = obj.x;
        const y = obj.y;
        const w = obj.width;
        const h = obj.height;

        if (turns === 3 || turns === -1) { // 90 deg counterclockwise
            obj.x = y;
            obj.y = 1 - x - w;
            obj.width = h;
            obj.height = w;
        }

        else if (turns === 2 || turns === -2) { // 180 deg clockwise
            obj.x = 1 - x - w;
            obj.y = 1 - y - h;
        }

        else if (turns === 1 || turns === -3) { // 90 deg clockwise
            obj.x = 1 - y - h;
            obj.y = x;
            obj.width = h;
            obj.height = w;
        }
    }

    for(const row of rows){
        const page = row.page??table.page;
        rotate(row, page); 
        for(const cell of row.cells??[]){
            rotate(cell, page); 
        }
    }

    return tbl; 
}